let locales = {
    parametizableText_routes: 'Abilita  le notifiche per la creazione di note (amministratori)',
    parametizableText_validatorUris:'Questa opzione è già stata selezionata',
};
export default locales;